<template>
  <div class="embed view">
    <!-- {{ dataCard }}  -->
    <injected-chart
      :config="{url: $route.fullPath, kpis: []}"
      :title="false"
      :visible="true"
    />
  </div>
</template>

<script>
// import { getItemById } from '@/services/api'
// import { getStatisticsTable } from '@/services/table-api'
import InjectedChart from '../components/charts/InjectedChart.vue'
export default {
  components:{InjectedChart},
  props: {},
  computed:{},
  asyncComputed: {},
}
</script>

<style lang="stylus" scoped>
.embed
  width 100vw
  height 100vh
  .injected-chart
    // max-width 700px
    // max-height 500px
    min-width 200px
    min-height 100px
    width 100%
    height 100%
    margin auto
</style>
